import React from 'react';
import { Box, List, ListItemText, ListItemButton, PopoverOrigin } from '@mui/material';
import * as Styled from './StyledComponents';
import { FmtpPage, UserMenuItem } from '../types';
import { useFmtpNavigate } from 'src/hooks/useFmtpNavigate';
import { NavLink } from 'react-router-dom';
import { addSessionId } from 'src/util/helpers';
import { PageNames } from 'src/util/types';
import ReportPicker from 'src/components/Views/Reports/ReportPicker';
import { Report } from '@lanterds/types';

export default function NavMenuPopover({
    pageName,
    items,
    handleClose,
    open,
    boxContainerClasses,
    popoverId,
    buttonId,
}: {
    pageName?: string;
    items: FmtpPage[] | UserMenuItem[] | Report[];
    handleClose: () => void;
    open: HTMLElement | null;
    anchorOrigin?: PopoverOrigin;
    transformOrigin?: PopoverOrigin;
    boxContainerClasses?: string;
    popoverId?: string;
    buttonId?: string;
}) {
    const fmtpNavigate = useFmtpNavigate();

    const handleButtonClick = (item: FmtpPage | UserMenuItem) => {
        handleClose();

        const isUserMenuItem = !!instanceOfUserMenuItem(item);

        if (item) {
            if (isUserMenuItem) {
                if (item.handler && item.href) {
                    item.handler();
                    fmtpNavigate(item.href);
                } else if (item.href) {
                    fmtpNavigate(item.href);
                } else if (item.handler) {
                    item.handler();
                }
            }
        }
    };

    // Intentionally using any as the type here.
    function instanceOfUserMenuItem(item: any): item is UserMenuItem {
        return 'handler' in item;
    }

    return (
        <Styled.MenuPopover
            open={!!open}
            anchorEl={open}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            id={popoverId}
        >
            {pageName === PageNames.Reports ? (
                <ReportPicker handleCloseDialog={handleClose} reportsList={items as Report[]} />
            ) : (
                <Box className={boxContainerClasses}>
                    <List disablePadding>
                        {(items as FmtpPage[] | UserMenuItem[]).map((item) =>
                            item.href ? (
                                <ListItemButton
                                    component={NavLink}
                                    key={item.name}
                                    to={addSessionId(item.href)}
                                    onClick={() => handleButtonClick(item)}
                                    id={buttonId}
                                >
                                    <ListItemText primary={item.displayText} />
                                </ListItemButton>
                            ) : (
                                <ListItemButton key={item.name} onClick={() => handleButtonClick(item)} id={buttonId}>
                                    <ListItemText primary={item.displayText} />
                                </ListItemButton>
                            ),
                        )}
                    </List>
                </Box>
            )}
        </Styled.MenuPopover>
    );
}
